import { render, staticRenderFns } from "./Agent.Detail.vue?vue&type=template&id=fe397978&"
import script from "./Agent.Detail.vue?vue&type=script&lang=js&"
export * from "./Agent.Detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports